<template>
  <div>
    AVULSOS
  </div>
</template>

<script>
export default {
  name: 'DetachedLink',

  props: {
    screen: {
      type: String,
      default: ''
    }
  },

  data: () => ({
  }),

  created() {
  },

  methods: {
  }
}
</script>